import { Box, Typography } from '@mui/material'
import { CustomerListItem } from 'pages/address/address.hooks'

interface AddressCustomerListItemProps {
  item: CustomerListItem
  isSelected: boolean
  onSelect: () => void
}

const AddressCustomerListItem = ({
  item,
  isSelected,
  onSelect,
}: AddressCustomerListItemProps) => {
  return (
    <Box
      onClick={onSelect}
      sx={{
        px: 2,
        py: 1.5,
        cursor: 'pointer',
        bgcolor: isSelected ? 'primary.main' : 'common.white',
        color: isSelected ? 'common.white' : 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          bgcolor: isSelected ? 'primary.main' : 'grey.50',
        },
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '0.9rem',
        }}
      >
        {item.companyName || '—'}
      </Typography>
    </Box>
  )
}

export default AddressCustomerListItem
